(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('tagsValuesService', tagsValuesService);

  function tagsValuesService(
    _,
    affiliateService,
    pingTreeTargetService,
    targetService,
    numberService,
    buyerService,
    featureFlags
  ) {
    'ngInject';

    const tagOptionsByCategory = {
      publisher: {
        loadingText: 'Loading Publishers',
        getData: affiliateService.getCachedAffiliates,
        responseProperty: 'affiliates',
        inputPlaceholder: 'Select Publisher'
      },
      buyer: {
        loadingText: 'Loading Buyers',
        getData: _fetchBuyers,
        responseProperty: 'buyers',
        inputPlaceholder: 'Select Buyer'
      },
      target: {
        loadingText: 'Loading Targets',
        getData: _fetchAllTargets,
        responseProperty: 'targets',
        inputPlaceholder: 'Select Target'
      },
      dialednumber: {
        loadingText: 'Loading Numbers',
        getData: numberService.getCachedNumbers,
        responseProperty: 'numbers',
        inputPlaceholder: 'Select Number'
      }
    };

    const autoCompleteTagOptions = {
      'publisher:id': {
        valueProperty: 'id',
        tagType: 'publisher',
        selectedDisplayProperty: 'id',
        secondaryProperty: 'name'
      },
      'publisher:company': {
        valueProperty: 'name',
        tagType: 'publisher'
      },
      'publisher:name': {
        valueProperty: 'name',
        tagType: 'publisher'
      },
      'buyer:name': {
        valueProperty: 'name',
        tagType: 'buyer'
      },
      'buyer:id': {
        valueProperty: 'id',
        tagType: 'buyer',
        selectedDisplayProperty: 'id',
        secondaryProperty: 'name'
      },
      'target:id': {
        valueProperty: 'id',
        tagType: 'target',
        selectedDisplayProperty: 'id',
        secondaryProperty: 'name'
      },
      'target:name': {
        valueProperty: 'name',
        tagType: 'target'
      },
      'dialednumber:number': {
        valueProperty: 'phoneNumber',
        tagType: 'dialednumber',
        selectedDisplayProperty: 'phoneNumber',
        displayProperty: 'phoneNumber'
      },
      'dialednumber:name': {
        valueProperty: 'name',
        tagType: 'dialednumber',
        filterProperty: 'name'
      }
    };

    const service = {
      checkIfDropdownToBeShown: checkIfDropdownToBeShown,
      getOptionsForDropdown: _.memoize(_getOptionsForDropdown),
      getTagDataFunction: _getMemoizedTagDataFunction()
    };

    return service;

    function checkIfDropdownToBeShown(tagId, tagIds) {
      if (tagId) {
        return _checkIfDropdownToBeShown(tagId);
      }

      if (tagIds) {
        tagId = _.find(tagIds, function (t) {
          return _checkIfDropdownToBeShown(t);
        });
        if (tagId) {
          return _checkIfDropdownToBeShown(tagId);
        }
      }      
    }

    function _checkIfDropdownToBeShown(tagId) {
      return autoCompleteTagOptions[tagId.toLowerCase()];
    }

    function _fetchBuyers(accountId) {
      return buyerService.getCachedBuyers(accountId);
    }

    function _fetchAllTargets(accountId) {
      let targets = [];

      return targetService.getCachedTargets(accountId).then(function (response) {
        targets = _.concat(targets, response.data.targets);
        if (featureFlags.isOn('pingtree')) {
          return pingTreeTargetService.getCachedTargets(accountId).then(function (response) {
            targets = _.concat(targets, response.data.pingTreeTargets);
          });
        }
      }).then(function () {
        return {
          data: {
            targets: targets
          }
        };
      });
    }

    function _getOptionsForDropdown(tagId) {
      if (_.isArray(tagId)) {
        const tag = _.find(tagId, function (t) {
          return autoCompleteTagOptions[t.toLowerCase()];
        });

        if (tag) {
          return _getOptionsForDropdownLogic(tag);
        }
      }
      else {
        return _getOptionsForDropdownLogic(tagId);
      }
    }

    function _getOptionsForDropdownLogic(tagId) {
      if (tagId) {
        const options = autoCompleteTagOptions[tagId.toLowerCase()];
      
        return options && _.merge(options, tagOptionsByCategory[options.tagType]);
      }
    }

    function _getMemoizedTagDataFunction() {
      return _.memoize(_returnGetDataFunction, function(actId, tagId, tagIds) {
        return actId + tagId + tagIds;
      });
    }

    function _returnGetDataFunction(accountId, tagId, tagIds) {
      if (tagId) {
        return _returnGetDataFunctionLogic(accountId, tagId);
      }

      if (tagIds) {
        const tag = _.find(tagIds, function (t) {
          return autoCompleteTagOptions[t.toLowerCase()];
        });

        if (tag) {
          return _returnGetDataFunctionLogic(accountId, tag);
        }
      }
    }

    function _returnGetDataFunctionLogic(accountId, tagId) {
      const options = autoCompleteTagOptions[tagId.toLowerCase()];

      return options && tagOptionsByCategory[options.tagType].getData.bind(null, accountId);
    }

  }
})();
